import { Box } from "@primer/react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { PlaceHolder } from "../../components/place-holder";
//import DangKyDichVu from './dich-vu/DangKyDichVu';
//import { GiayToNopForm } from './giay-to-nop';
import { phuHuynhApi } from "../../api/phuHuynhApi";
import Modal from "../../components/ui/modal";
import QuanHeGiaDinhPhuHuynh from "./gia-dinh";
import { PhuHuynhProfileListTab } from "./list-tab";
import { PhuHuynhProfileTabs } from "./list-tab/PhuHuynhProfileListTab";
import { PhuHuynhNameAndAvavtar } from "./name-and-avatar";
//import { ProfileForm } from './profile-form';

interface PhuHuynhProfileProps {
  id: number;
  value?: number;
  height?: number;
  phuHuynh?: any;
  onClose: () => void;
  onSuccess: () => void;
}


const PhuHuynhProfile = (props: PhuHuynhProfileProps) => {
  const { id } = useParams<{ id: string }>();
  const [PhuHuynh, setPhuHuynh] = useState<any>({ id: props.id });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState<string>("dashboard");
  const componentDidMount = useRef(false);

  useEffect(() => {
    setPhuHuynh({ id: props.value });
  }, [props.value, id]);

  useEffect(() => {
    componentDidMount.current = true;
    if (PhuHuynh.id > 0) {
      handleGetPhuHuynhData();
    }
    return () => {
      componentDidMount.current = false;
    };
  }, [PhuHuynh.id]);

  const handleGetPhuHuynhData = async () => {
    setIsLoading(true);
    const res = await phuHuynhApi.getById(PhuHuynh.id);
    if (!componentDidMount.current) return;
    setIsLoading(false);
    if (res.is_success) {
      setPhuHuynh(res.data);
    }
  };

  const PhuHuynhProfileTab = useMemo(() => {
    return PhuHuynhProfileTabs.find((x) => x.id === selectedTab);
  }, [selectedTab]);

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      width={"1000px"}
      title={"Thông tin"}
    >
      <Box className="container" p={0}>
        <Box
          className="top-side"
          mb={0}
          pb={1}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {isLoading && <PlaceHolder line_number={2} />}
          {!isLoading && (
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              flexGrow={1}
            >
              <PhuHuynhNameAndAvavtar key={PhuHuynh.id} phuHuynh={PhuHuynh} />
              <Box flexGrow={1}>
                <PhuHuynhProfileListTab
                  selectedTab={selectedTab}
                  PhuHuynhId={PhuHuynh.id}
                  onTabSelectionChanged={setSelectedTab}
                />
              </Box>
            </Box>
          )}
        </Box>

        <Box
          className="bottom-side"
          overflow="auto"
          height={props.height ?? window.innerHeight - 300}
        >
          <Box className="content">
            <Box p={0}>
              {/* {selectedTab === "profile" && (
                <ProfileForm
                  ref={profileFormRef}
                  key={PhuHuynh.id}
                  phuHuynh={PhuHuynh}
                  // height={height ? height - 70 : window.innerHeight - 240}
                  // phuHuynh={phuHuynh}
                  onSubmitSuccess={(id: any) => {
                    if (PhuHuynh.id > 0) {
                      handleGetPhuHuynhData();
                    } else {
                      setPhuHuynh({ id });
                    }
                    props.onSuccess();
                  }}
                />
              )} */}
              {selectedTab === "dashboard" && (
                <QuanHeGiaDinhPhuHuynh id={PhuHuynh.id} />
              )}
              {/* {selectedTab === "discount" && (
                <HinhThucMienGiam PhuHuynh={PhuHuynh} />
              )}
         {selectedTab === "service" && (
                <DangKyDichVu PhuHuynh={PhuHuynh} />
              )}  */}
              {/* {selectedTab === "document" && (
              <GiayToNopForm PhuHuynh={PhuHuynh} onUploadedAvatar={handleGetPhuHuynhData} />
            )}
            {selectedTab === "familly" && <QuanHeGiaDinhPhuHuynh PhuHuynh={PhuHuynh} />}
            {selectedTab === "discount" && <HinhThucMienGiam PhuHuynh={PhuHuynh} />} 
            {selectedTab === "service" && (
              <DangKyDichVu PhuHuynh={PhuHuynh} height={height ? height - 70 : window.innerHeight - 240} />
            )} */}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default PhuHuynhProfile;
